import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("sat_token");
    if (!t) { setReady(true); return; }
    api.get("/auth/me")
      .then(r => setUser(r.data))
      .catch(() => setToken(null))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (email, password, call_sign) => {
    const r = await api.post("/auth/register", { email, password, call_sign });
    setToken(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    // Defer clearing user to next microtask so any concurrent navigate()
    // committed by the caller flushes to a public route first, preventing
    // ProtectedRoute at /pilot from evaluating with user=null and forcing
    // a bounce to /auth.
    setToken(null);
    queueMicrotask(() => setUser(null));
  };

  const acceptTerms = async () => {
    const r = await api.post("/auth/accept-terms");
    setUser(u => u ? { ...u, terms_accepted_at: r.data.terms_accepted_at } : u);
    return r.data.terms_accepted_at;
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, logout, acceptTerms }}>
      {children}
    </AuthCtx.Provider>
  );
}
